// extracted by mini-css-extract-plugin
module.exports = {"comparison-view-container":"style_comparison-view-container__24LVO","plus-icon":"style_plus-icon__C3am5"};